import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { directoryData, prayerRequestData } from './landingPageData'

const delay = (ms) =>
  new Promise(resolve => setTimeout(resolve, ms));

const initialState = { 
    directories: directoryData, 
    posts: prayerRequestData, 
    likePostLoading: -1,
    giveBtnLoading: false,
    giveBtnClicked: false,
    eventRsvped: false,
    eventRsvpLoading: false,
}
 
export const setLikeFirstPost = createAsyncThunk(
    'landingPage/setLikeFirstPost',
    async (_, thunkAPI) => {
        const state = thunkAPI.getState().landingPage; 

        // simulate loading
        await delay(1400);

        const firstPost = state.posts[0];
        if (!firstPost) return state.posts;

        const updatedPost = {
        ...firstPost,
        praying: true,
        };

        return [updatedPost, ...state.posts.slice(1)];
    }
);

export const clickGiveButton = createAsyncThunk(
    'landingPage/clickGiveButton',
    async (_, thunkAPI) => { 
 
        await delay(1400);
        return true;
    } 
); 


export const rsvpEvent = createAsyncThunk(
    'landingPage/rsvpEvent',
    async (_, thunkAPI) => {
        await delay(1400);
        return true;
    }
);

export  const landingPageSlice = createSlice({
    name: 'landingPage',
    initialState,
    reducers: {
        lpReset: (state) => initialState,
        
        setDirectories: (state, action) => {
            state.directories = action.payload
        },

        setLikePost: (state, action) => {
            const postId = action.payload;
            state.posts = state.posts.map(post => {
                if (post.id === postId && postId !== 1) {
                    return { ...post, praying: !post.praying };
                }
                return post;
            }
            );
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setLikeFirstPost.pending, (state) => {
                state.likePostLoading = 1;
            })
            .addCase(setLikeFirstPost.fulfilled, (state, action) => {
                state.likePostLoading = -1; 
                state.posts = action.payload;
            })   
            .addCase(clickGiveButton.pending, (state) => {
                state.giveBtnLoading = true;
            })
            .addCase(clickGiveButton.fulfilled, (state, action) => {
                state.giveBtnClicked = true;
                state.giveBtnLoading = false;
            })
            .addCase(rsvpEvent.pending, (state) => {
                state.eventRsvpLoading = true;
            })
            .addCase(rsvpEvent.fulfilled, (state, action) => {
                state.eventRsvped = true;
                state.eventRsvpLoading = false;
            })
        }
    })


export const { lpReset, setDirectories,setLikePost } = landingPageSlice.actions
export default landingPageSlice.reducer
 